module.exports = __webpack_public_path__ + "static/img/login-bg.92f22f40.png";